import { initContract } from '@ts-rest/core';
const c = initContract();
// ============ deleteProject ============
// No specific types needed - returns void
// ============ Contract ============
export const projectContract = c.router({
    listProjects: {
        method: 'GET',
        path: '/projects',
        responses: {
            200: c.type(),
        },
    },
    getProject: {
        method: 'GET',
        path: '/projects/:id',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    createProject: {
        method: 'POST',
        path: '/projects',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateProject: {
        method: 'PUT',
        path: '/projects/:id',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    deleteProject: {
        method: 'DELETE',
        path: '/projects/:id',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
});
//# sourceMappingURL=project.js.map